<template>
  <QuestionBody :qsNumber="qsNumber" :nextPage="nextPage" :navigateType="navigateType" :content="content" />
</template>

<script>
import QuestionBody from '@/layout/QuestionBody.vue'
export default {
  name: "Qs2-06",
  components: {
    QuestionBody
  },
  data() {
    return {
      qsNumber: 26,
      navigateType: 'CLICK_ANY_BTN',
      content: {
        componentsType: {
          pc: 'longBtn',
          mobile: 'normalBtn'
        },
        titleIcon: require('@/assets/icon/questionIcon/25-Immunity.png'),
        mainTitle: 'How long does it take you to recover from a cold?',
        btn: [
          [
            {
              text: '2-3 days',
            }
          ],[
            {
              text: 'about a week',
            }
          ],[
            {
              text: '2-3 weeks',
            }
          ],[
            {
              text: 'more than 3 weeks',
            }
          ]
        ]
      }
    }
  },
  computed: {
    nextPage: function(){
      if(this.$store.state.qsData[21] && this.$store.state.qsData[21].answer.length>0){
        if(this.$store.state.qsData[21].answer.indexOf('Digestion') !== -1){
          return '/questionnaire/section2/7'
        }else if(this.$store.state.qsData[21].answer.indexOf('Skin') !== -1){
          return '/questionnaire/section2/9'
        }else if(this.$store.state.qsData[21].answer.indexOf('Hair') !== -1){
          return '/questionnaire/section2/11'
        }else if(this.$store.state.qsData[21].answer.indexOf('Emotion') !== -1){
          return '/questionnaire/section2/13'
        }else if(this.$store.state.qsData[21].answer.indexOf('Menstrual problems') !== -1){
          return '/questionnaire/section2/16'
        }else if(this.$store.state.qsData[21].answer.indexOf('Women\'s Health') !== -1){
          return '/questionnaire/section2/18'
        }else{
          return '/questionnaire/section3'
        }
      }else{
        return '/questionnaire/section3'
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
